import PaypalCheckout from './PaypalCheckout';

export default PaypalCheckout;



// WEBPACK FOOTER //
// ./src/common/components/PaypalCheckout/index.js